function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M11.0832 4.08333V6.41667H3.40067L5.489 4.3225L4.6665 3.5L1.1665 7L4.6665 10.5L5.489 9.6775L3.40067 7.58333H12.2498V4.08333H11.0832Z",
  fill: "#737376"
});
function SvgKeyUp({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKeyUp);
export default __webpack_public_path__ + "static/media/key_up.13888132.svg";
export { ForwardRef as ReactComponent };